
























































































































import {Component, Vue} from 'vue-property-decorator'
import {EnvHelper} from '@/helpers/EnvHelper'

@Component
export default class SignInView extends Vue {
  loginGoogle() {
    const clientID = EnvHelper.VUE_APP_OAUTH_GOOGLE_CLIENT_ID
    const redirectURI = EnvHelper.VUE_APP_OAUTH_GOOGLE_REDIRECT_URI

    const params = new URLSearchParams()

    params.set('client_id', clientID)
    params.set('redirect_uri', redirectURI)
    params.set('response_type', 'code')
    params.set('scope', 'openid email profile')
    params.set('include_granted_scopes', 'true')
    params.set('access_type', 'offline')
    params.set('state', String(Math.random()))

    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params}`
  }
}
